import $ from 'jquery';
import { U as Url } from './url.min.js';

/*
 * Mews System
 */
function factory({ window, document, thn }) {

  const engine = {};

  const iframeMews = document.querySelector('body > iframe.mews-distributor');
  const isNotBEpage = !iframeMews || parseFloat(iframeMews.style.opacity) === 0;
  const propertyNeedsLangCheckOnIndex = [1037546, 1156123, 1156124, 1156125, 1156126].includes(thn.data.propertyId);
  const isLivingSuites = thn.data.propertyId === 1034573;
  const twoPaxHotelsList = [
    1034573, // Living Suites
  ];

  /**
     * @memberOf module:bs_163
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {

    thn.data.mewsCurrencies = {
      ƒ: 'ANG',
      A$: 'AUD',
      CHF: 'CHF',
      'CN¥': 'CNY',
      COL$: 'COP',
      '₡': 'CRC',
      Kč: 'CZK',
      DKK: 'DKK',
      '€': 'EUR',
      '£': 'GBP',
      GEL: 'GEL',
      Q: 'GTQ',
      FT: 'HUF',
      RP: 'IDR',
      '₪': 'ILS',
      ISK: 'ISK',
      'JP¥': 'JPY',
      KSH: 'KES',
      DH: 'MAD',
      RS: 'MUR',
      MEX$: 'MXK',
      N$: 'NAD',
      NOK: 'NOK',
      NZ$: 'NZD',
      'B/.': 'PAB',
      'S/.': 'PEN',
      '₱': 'PHP',
      zł: 'PLN',
      '₽': 'RUB',
      '﷼': 'SAR',
      SR: 'SCR',
      SEK: 'SEK',
      S$: 'SGD',
      '฿': 'THB',
      '₺': 'TRY',
      $: 'USD',
      CFA: 'XOF',
      R: 'ZAR',
    };

    thn.data.mewsLanguages = {
      Català: 'ca',
      Dansk: 'da',
      'Deutsch (Deutsch)': 'de',
      'Deutsch (Schweizer)': 'de',
      'Eesti keel': 'ee',
      'English (British)': 'en',
      'English (United States)': 'en',
      Español: 'es',
      Euskara: 'eu',
      Français: 'fr',
      Italiano: 'it',
      Melayu: 'ms',
      Nederlands: 'nl',
      Norsk: 'nb',
      Polski: 'pl',
      Português: 'pt',
      Slovenčina: 'sk',
      Suomi: 'fi',
      Svenska: 'sv',
      Türkçe: 'tr',
      íslenska: 'is',
      Čeština: 'cs',
      Ελληνικά: 'el',
      Русский: 'ru',
      'українська мова': 'uk',
      தமிழ்: 'ta',
      'ქართული ენა': 'ka',
      中文: 'zh',
      日本語: 'ja',
      한국말: 'ko',
    };

    thn.data.mewsBed = {
      default: 'Bed in',
      en: 'Bed in',
      de: 'Bett im',
    };

    // Some properties need this observer when the Index page comes in a lang and in R&R automatically change into another
    // We have to exclude other Pid, as the observer is making the PW refesh too many times and duplicating notes
    thn.mewsRefreshLanguage = function thnMewsRefreshLanguage() {
      // Recheck lang once the page has changed
      if (thn.data.language) {
        thn.languageCheck().then(function ({ changed }) {

          if (!changed
            && ['Rooms and Rates', 'Packages'].includes(thn.data.pageName)
            && thn.widgets.price.refresh()
            && !thn.widgets.price.isSet()
          ) {

            thn.widgets.price.hide();
          }
        });
      }
    };

    // Not all properties has the possibility to apply a 1 click promocode using the URL
    // For those exceptions, we should declare this function on property.promocode_vas as property 1027112
    thn.mews_apply_promocode = function thnMewsApplyPromocode(data) {

      const mews = window.Mews;
      const mewsDistributorKey = window.dataLayer && thn.objectGet(window.dataLayer, 'hotelId', { first: false });

      const distributorLangCodes = {
        ca: 'ca-ES',
        da: 'da-DK',
        de: 'de-DE',
        ee: 'et-EE',
        en: 'en-US',
        es: 'es-ES',
        eu: 'eu-ES',
        fr: 'fr-FR',
        it: 'it-IT',
        ms: 'ms-MY',
        nl: 'nl-NL',
        nb: 'nb-NO',
        pl: 'pl-PL',
        pt: 'pt-PT',
        sk: 'sk-SK',
        fi: 'fi-FI',
        sv: 'sv-SE',
        tr: 'tr-TR',
        is: 'is-IS',
        cs: 'cs-CZ',
        el: 'el-GR',
        ru: 'ru-RU',
        uk: 'uk-UA',
        ta: 'ta-IN',
        ka: 'ka-GE',
        zh: 'zh-CN',
        ja: 'ja-JP',
        ko: 'ko-KR',
      };

      const dateBegin = thn.widgets.price.data.dateBegin;
      const dateEnd = thn.widgets.price.data.dateEnd;
      const currency = thn.widgets.price.data.currency;
      const language = distributorLangCodes[thn.data.language];

      if (thn.data.pageName === 'Rooms and Rates'
        && mews
        && mewsDistributorKey
        && dateBegin
        && dateEnd
        && currency
        && language) {
        // Remove previous distributor(s)
        [...document.querySelectorAll('.mews-distributor')].forEach((e) => e.remove());
        // Launch distributor
        mews.Distributor({
          configurationIds: [mewsDistributorKey],
        },
        function (distributor) {
          distributor.open();
          distributor.setLanguageCode(language);
          distributor.setCurrencyCode(currency);
          distributor.setStartDate(new Date(dateBegin));
          distributor.setEndDate(new Date(dateEnd));
          distributor.setVoucherCode(data.code);
          distributor.showRooms(mewsDistributorKey);
        });
        // API reference
        // https://mews-systems.gitbook.io/distributor-guide/distributor-widget/advanced-guide
      }
    };
    const menuContainer = document.getElementById('overlay');
    if (menuContainer) {
      const refreshPage = thn.debounce(() => {
        thn.pageCheck();
      }, 800);
      thn.observeDom(menuContainer, refreshPage, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(menuContainer, refreshPage);
      });
    }

    thn.domReady().then(function () {

      const container = document.documentElement;
      if ([1030241].includes(thn.data.propertyId) && window.location.hostname !== 'www.mews.li') {

        if (container) {
          const maisonmereRefreshPage = thn.debounce(function () {
            if (thn.data.pageName === 'Rooms and Rates') {
              setTimeout(() => thn.widgets.price.refresh(), 400);
            } else {
              thn.pageCheck();
            }
          }, 1000);
          thn.maisonmerePage = function maisonmereObserver() {
            const iframeContent = document.querySelector('iframe.mews-distributor').contentWindow.document.body.querySelector('#distributor');
            if (iframeContent) {
              maisonmereRefreshPage();
            }

          };
          thn.observeDom(container, thn.maisonmerePage, {
            childList: true,
            subTree: true,
            attributes: true,
          });

          thn.shutdown(() => {
            maisonmereRefreshPage.cancel();
            thn.stopObserveDom(container, thn.maisonmerePage);
            delete thn.maisonmerePage;
          });
        }

      }

      if (container && propertyNeedsLangCheckOnIndex && isNotBEpage) {
        const refreshLang = thn.debounce(thn.languageCheck, 400);

        thn.observeDom(container, refreshLang, {
          childList: true,
        });

        thn.shutdown(() => {
          refreshLang.cancel();
          thn.stopObserveDom(container, refreshLang);
        });
      }

      if (!document.querySelector || !$) {
        return;
      }

      let $iframe;
      let $iframeBody;
      let iframeObserver;

      let $iframeBreadcrumb;
      let iframeBreadcrumbObserver;

      const pageCheckEventsList = [
        'Closed', 'Step Dates', 'Step Rooms', 'Step Rates', 'Step Summary', 'Booking Prepared', 'Step Confirmation', 'Application Loaded', 'Offered Dates Selected', 'Availability Loaded', 'Rates Loaded', 'Summary Loaded', 'Categories Loaded', 'Calendar Loaded', 'Confirmation Loaded',
        'StepDates', 'CalendarLoaded', 'StepRooms', 'CalendarLoaded', 'AvailabilityLoaded', 'StepRates', 'RatesLoaded', 'SummaryLoaded', 'DetailsLoaded',
      ];

      const listener = function _listener(model, { eventName, languageCode }) {
        const shouldPageCheck = pageCheckEventsList.some((possibleEventName) => eventName?.includes(possibleEventName));
        // const isNotRoomsAndRates = ['Rates Loaded', 'Summary Loaded', 'Calendar Loaded', 'Step Dates'].some((possibleEventName) => eventName?.includes(possibleEventName));

        const timer = setTimeout(function () {
          if (eventName === 'Language Code Changed') {
            thn.data.mewsSelectedLanguage = languageCode && (languageCode.split('-') || '')[0];
            thn.mewsRefreshLanguage();
          }
          if (eventName === 'Currency Code Changed' && thn.data.pageName === 'Rooms and Rates' && !isLivingSuites) {
            thn.widgets.price.update();
          }

          if (shouldPageCheck) {
            const pageCheck = thn.debounce(thn.pageCheck, 1000, { maxWait: 1200 });
            pageCheck();

            if (thn.data.pageName === 'Rooms and Rates') {
              if (isLivingSuites) {
                if (eventName === 'Categories Loaded') {
                  thn.widgets.price.refresh();
                }
              } else {
                thn.widgets.price.refresh();
              }
            }
          }

        }, 800);

        thn.shutdown(() => clearTimeout(timer));

      };

      if (!thn.mewsLanguageChangeObserver && window.dataLayer) {
        thn.mewsLanguageChangeObserver = new thn.DataLayerHelper(window.dataLayer, listener, true);
        thn.shutdown(() => {
          thn.mewsLanguageChangeObserver?.cancel();
          delete thn.mewsLanguageChangeObserver;
        });
      }

      function startIframeObservation($i) {
        // Stop current iframe observers
        if ($iframeBody && $iframeBody.length) {
          thn.stopObserveDom($iframeBody.get(0), iframeObserver);

          // Stop his breadcrumb observer
          if ($iframeBreadcrumb && $iframeBreadcrumb.length) {
            thn.stopObserveDom($iframeBreadcrumb.get(0), iframeBreadcrumbObserver);
          }
        }

        $iframe = $i;
        $iframeBody = $iframe.contents().find('body');
        $iframeBreadcrumb = undefined;
        thn.data.mewsIframeVisible = false;

        const iframeObserverConfig = {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style'],
        };

        iframeObserver = thn.debounce(function () {

          const isVisible = !($iframe.is(':hidden') || $iframe.css('opacity') === '1');

          // Refresh page if the iframe hides or shows
          if (isVisible !== thn.data.mewsIframeVisible) {

            thn.pageCheck();

            thn.data.mewsIframeVisible = isVisible;

            // Observe currency and language changes
            if ([1035249, 1041043, 1039297].includes(thn.data.accountUserId) && $iframe && $iframe.length) {

              $iframe.contents().on('click', '[class*="UppercasedMenuItem"][value][tabindex], .style__ListItemContainerElement-gexPQc', (e) => {
                const targetText = e.target.textContent;

                if (targetText.match(/[a-z]/)) {
                  thn.data.mewsSelectedLanguage = thn.data.mewsLanguages[targetText];
                  thn.languageCheck();
                } else if (!targetText.match(/[a-z]/)) {
                  if (targetText.length > 3 && targetText !== 'COL$' && targetText !== 'MEX$') {
                    thn.data.mewsCurrency = targetText.slice(0, 3);
                  } else if (targetText.match(/[A-Z]{3}/) && targetText !== 'CFA' && targetText !== 'KSH' && targetText !== 'COL$') {
                    thn.data.mewsCurrency = targetText;
                  } else {
                    thn.data.mewsCurrency = thn.data.mewsCurrencies[targetText];
                  }
                }

                thn.pageCheck();
              });
            }
          }

          // If we don't have the breadcrumb of this iframe yet, search for it
          if (!$iframeBreadcrumb || !$iframeBreadcrumb.length) {
            let $newIframeBreadcrumb = $iframeBody && $iframeBody.contents().find('#portal-container')
              .next()
              .children()
              .first();

            if ($newIframeBreadcrumb && !$newIframeBreadcrumb.length) {
              $newIframeBreadcrumb = $iframeBody.contents().find('[class*=StepBarContainer]');
            }

            // Breadcrumb found
            if ($newIframeBreadcrumb && $newIframeBreadcrumb.length) {
              $iframeBreadcrumb = $newIframeBreadcrumb;

              // Start breadcrumb observer
              thn.observeDom($iframeBreadcrumb.get(0), iframeBreadcrumbObserver, {
                childList: true,
                attributes: true,
                attributeFilter: ['class', 'style'],
              });

              // Manually execute the observer (to get the current page)
              iframeBreadcrumbObserver();

              // Change the config of the observer for not search for the breadcrumb anymore
              thn.observeDom($iframe.get(0), iframeObserver, Object.assign(iframeObserverConfig, { childList: false, subtree: false }));

              thn.shutdown(function () {
                thn.stopObserveDom($iframe.get(0), iframeObserver);
                thn.stopObserveDom($iframeBreadcrumb.get(0), iframeBreadcrumbObserver);
              });
            }
          }
        }, 1000, { maxWait: 1200 });

        const auxIframe = $('iframe.mews-distributor:last, iframe.mews-distributor');
        iframeBreadcrumbObserver = thn.debounce(function () {
          // Wait till loading finish for correctly determine the page
          const iframeIsLoading = setInterval(function () {
            if (auxIframe) {
              if (auxIframe.contents().find('svg[class*=ProgressCircularSvg], [class*=style__CircleLoaderWrapper]').length === 0) {
                thn.logger.debug('************** Checking page after loading finishes *****************');
                clearInterval(iframeIsLoading);
                thn.pageCheck();
              }
            }
          }, 1000);
        }, 1200, { maxWait: 1400 });

        // Start the observer
        thn.observeDom($iframeBody.get(0), iframeObserver, iframeObserverConfig);

        thn.shutdown(function () {
          thn.stopObserveDom($iframeBody.get(0), iframeObserver, iframeObserverConfig);
        });

        // Manually execute the observer (the iframe could be already visible)
        iframeObserver();
      }

      const bodyObserver = thn.debounce(function () {
        const $newIframe = $('iframe.mews-distributor:last, iframe.mews-distributor');

        // If there is a new iframe, start observing it
        if ($newIframe.length && (!$iframe || !$iframe.length || $newIframe.attr('name') !== $iframe.attr('name'))) {
          startIframeObservation($newIframe);
        }
      }, 600);

      // Observe the body for future iframes
      thn.observeDom(document.querySelector('body'), bodyObserver, {
        childList: true,
      });

      thn.shutdown(function () {
        thn.stopObserveDom(document.querySelector('body'), bodyObserver);
      });

      // Manually execute the observer (the iframe could already be inside the body)
      bodyObserver();

    });

    thn.shutdown(function () {
      delete thn.mewsLanguageChangeObserver;
      delete thn.data.mewsCurrencies;
      delete thn.data.mewsCurrency;
      delete thn.data.mewsLanguages;
      delete thn.data.mewsBed;
      delete thn.mewsRefreshLanguage;
      delete thn.data.mewsSelectedLanguage;
      delete thn.data.mewsIframeVisible;
      delete thn.mews_apply_promocode;
    });

  };

  engine.inlinerGetContext = function inlinerGetContext() {
    const ctx = {};

    const $iframe = ($ && $('iframe.mews-distributor:last, iframe.mews-distributor'));

    // When the Rooms and Rates iframe is present and visible
    if ($iframe && $iframe.length && parseFloat($iframe.css('opacity')) > 0.5) {
      ctx.window = $iframe.get(0).contentWindow;
      ctx.document = ctx.window.document;
    }

    return ctx;
  };

  // If the modal is open/close, we need to check the page.
  const pageCheckModal = thn.debounce(function () {
    thn.pageCheck();
  }, 400);

  /**
     * @memberOf module:bs_163
     * @see {@link onHashChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onHashChange = function onHashChange(ctx) {
    pageCheckModal();
  };

  /**
     * @memberOf module:bs_163
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    pageCheckModal();
  };
  /**
     * @memberOf module:bs_163
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      thn.domReady().then(function () {

        if (!$) {
          reject('no_language');
        }

        let lang;

        // BigMamaHotels
        const bigMamaHotelsLang = document.querySelector('.current')?.textContent;
        if (bigMamaHotelsLang && isNotBEpage) {
          resolve(bigMamaHotelsLang);
          return;
        }

        // Hôtel Terminal Neige Totem & Victoria Lodge
        if (thn.data.accountUserId === 1040207) {
          lang = document.documentElement.lang || 'fr';
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        // Landgoed Hotel & Restaurant Groot Warnsborn, Getaway Hotels
        // HOMEPAGE: It is homepage if opacity === 0 or there is no iframeMews
        if (propertyNeedsLangCheckOnIndex && isNotBEpage) {
          lang = document.querySelector('.lang a')?.textContent?.toLowerCase() || document.documentElement.lang;
          lang = lang === 'auto' ? 'nl' : lang;
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        lang = thn.data.mewsSelectedLanguage || (thn.parseUrlParameter(window.location.hostname.match(/staygenerator.com/) ? 'lang' : 'language').split('-') || '')[0];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_163
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */

  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new Url(ctx.baseUrl);
    const validHosts = [
      'app.mews', 'api.mews',
      'laposch', 'pentahotels',
      'oasihotel', 'benvengudo',
      'bigmamahotels', 'bambuda',
      'folkshotels', 'bourgogne-montana',
      'hotelaalders', 'staygenerator',
    ];
    const validPaths = ['reservation', 'book'];

    const validUrl = validHosts.some((host) => url.host.includes(host)) || validPaths.some((path) => url.path.includes(path));
    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    // For Pentahotels Bremen. Signed with KITT
    // https://app.mews.com/distributor/df26c674-f588-4962-b804-aebd00a786e9?mewsStart=2024-11-28&mewsEnd=2024-11-29&mewsAdultCount=1&language=de&currency=EUR&mewsChildCount=0
    if (url.host === 'www.pentahotels.com') {
      url.host = 'app.mews.com';
      url.path = '/distributor/df26c674-f588-4962-b804-aebd00a786e9';
    }

    // Refer to the following URL to have more information regarding the GHet Method on Mews (deeplinks)
    // https://mews-systems.gitbook.io/distributor-guide/distributor-widget/advanced-guide#deeplinks
    // Normal URL: https://www.wombats-hostels.com/
    // URL generated: https://www.wombats-hostels.com/?mewsDistributorOpened&currency=EUR&mewsRoute=rooms&mewsHotel=b43b350a-7230-4211-81a8-6b93413fd5c1&mewsStart=2021-08-05&mewsEnd=2021-08-05&mewsVoucherCode=PROMOCODE

    // 'mewsDistributorOpened' parameter tells mews to automatically open the model window where Mews is (opens the BE)
    url.query.mewsDistributorOpened = '';

    // 'mewsRoute' parameter tells mews to open the Rooms and Rates page directly
    url.query.mewsRoute = 'rooms';

    url.query.mewsStart = ctx.data.dateBegin.replace(/\//g, '-');
    url.query.mewsEnd = ctx.data.dateEnd.replace(/\//g, '-');
    url.query.mewsAdultCount = ctx.data.roomsDispo[0]?.adults || 2;
    url.query.mewsChildCount = ctx.data.roomsDispo[0]?.children || 0;

    /**
         * The datalayer is needed, on the URL we have to generate in the case where the we can change the property inside the BE (coporative pages)
         *  - example -> https://www.wombats-hostels.com/
         * For individual hotels, this parameters should be necessary
         *
         * We need to add the partnership-hotel-id on the URL to tell Mews which property to open
         * if this parameter is not given, we will be redirected to the calendar page, where we select an hotel (hotel step)
         * This value is found on the dataLayer
         */
    if (window.dataLayer) {
      url.query.mewsHotel = thn.objectGet(window.dataLayer, 'hotelId', { first: false });
    }

    url.query.currency = ctx.data.currency;
    url.query.language = ctx.data.language;

    // export into ctx.new_url
    ctx.newUrl = url.decode(url.toString());

    // then format of dates: yyyy/mm/dd -> yyyy-mm-dd
    ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/\//g, '-');
    ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/\//g, '-');

    return ctx;
  };

  /**
     * @memberOf module:bs_163
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    if (!$) {
      return;
    }

    const $iframe = $('iframe.mews-distributor:last, iframe.mews-distributor');
    const $iframeBody = $iframe && $iframe.contents().find('body');
    let $container = $iframeBody && $iframeBody.contents().find('#portal-container')
      .next()
      .find('div')
      .next('div:eq(0)');
    if ($container && !$container.length) {
      $container = $iframeBody.contents().find('[class*=ContentContainer]');
    }

    if ($container && $container.length) {
      thn.mewsPriceObserver = thn.debounce(function thnMewsRatesObserver() {
        if (!['Rooms and Rates', 'Packages'].includes(thn.data.pageName)) {
          return;
        }
        const loading = $('svg[class*=ProgressCircularSvg], [class*=style__CircleLoaderWrapper]:visible', $container).length > 0;
        // If not loading, refresh the PW and if PW is not set, hide it
        // For some properties the PW is reloading too often, so we limit them
        // Living Suites (Pid 1034573)

        const isBlacklistCheckLang = !isLivingSuites;

        if (!loading && isBlacklistCheckLang) {
          ctx.widget.refresh();
          thn.languageCheck();
          thn.pageCheck();
        }
      }, 800);

      thn.observeDom($container.get(0), thn.mewsPriceObserver);

      thn.pageUnload(function () {
        thn.stopObserveDom($container.get(0), thn.mewsPriceObserver);
        delete thn.mewsPriceObserver;
      });
    }
  };

  /**
     * @memberOf module:bs_163
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    const isWytheHotel = thn.data.accountUserId === 1048597;
    const isPolaGiverolaCamp = thn.data.propertyId === 1043687;
    const isHotelWithTwoPax = twoPaxHotelsList.includes(thn.data.propertyId);

    const dataLayer = window.dataLayer;
    const iframes = document.querySelectorAll('iframe.mews-distributor:last-of-type, iframe.mews-distributor');
    const iframeFiltered = iframes && Array.from(iframes)?.filter((el) => el.getAttribute('title'))?.[0];
    const iframeBody = iframeFiltered && iframeFiltered.contentDocument?.body;
    let container = iframeBody && iframeBody.querySelector('#portal-container')
      ?.nextElementSibling
      ?.querySelector('div')
      ?.nextElementSibling;

    if (!container) {
      container = iframeBody.querySelectorAll('[class^=Card] [class^=Stack-] [class^=StackItem], [data-test-textkey=NoMoreAvailabilityMessage]');
    }

    const loading = !container || thn.isVisible(document.querySelector('[class*=style__CircleLoaderWrapper]')) || document.querySelectorAll('svg[class*=ProgressCircularSvg]').length > 0;

    if (loading || !dataLayer) {
      return widgetData;
    }

    if (isWytheHotel && !!thn.dataLayerHelper.get('promoCode')) {
      return widgetData;
    }

    widgetData.language = thn.data.language;

    // Dates
    const startDate = iframeBody.querySelectorAll('*[class^="selectedDates__ClickableElement"] span:nth-child(2)')?.[0] || iframeBody.querySelectorAll('[data-test-textkey^=DayShort]')?.[0]?.nextElementSibling?.textContent;
    const endDate = iframeBody.querySelectorAll('*[class^="selectedDates__ClickableElement"] span:nth-child(2)')?.[2] || iframeBody.querySelectorAll('[data-test-textkey^=DayShort]')?.[1]?.nextElementSibling?.textContent;

    widgetData.dateBegin = ((thn.objectGet(dataLayer, 'startDate', { first: false }) || '').replace(/-/g, '/') || ((startDate || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
    widgetData.dateEnd = ((thn.objectGet(dataLayer, 'endDate', { first: false }) || '').replace(/-/g, '/') || ((endDate || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));

    // Price
    const priceSelectors = 'div[class*=PriceContainer] span, [class*="style__Price"] span, [class*="MediumImportanceHighlight"] span, [class*="HighImportanceHighlight"] span, strong[class*=MajorHighlight], [data-test-id=from-price-value], [data-test-id="from-price-wrapper"]';

    // First look for prices, then find the parent in order to avoid unavailable rooms that show but have no price
    const allRooms = [...container].map((room) => room.querySelector(priceSelectors)?.closest('div[data-test-id="category-card"]')) || [];

    // Filter out shared rooms: If all rooms are shared, price will be undefined leading to "No rooms" status.
    const rooms = allRooms.filter((_, room) => {
      let text = thn.data.mewsBed[widgetData.language] || thn.data.mewsBed.default;
      // Pola Giverola Camp - We need to exclude price for PACELA.
      if (isPolaGiverolaCamp) {
        text = 'PARCELA';
      }
      return !allRooms[room]?.querySelector('[class*=SubsectionTitle] span')?.textContent?.contains(text);
    }).filter(Boolean);

    const cheapestRoom = [...rooms].sort(function (prev, next) {
      const prevPriceEl = prev?.querySelector(priceSelectors);
      const nextPriceEl = next?.querySelector(priceSelectors);

      const prevPrice = prevPriceEl ? thn.parseNumber(prevPriceEl?.textContent) : Infinity;
      const nextPrice = nextPriceEl ? thn.parseNumber(nextPriceEl?.textContent) : Infinity;

      return prevPrice - nextPrice;
    })?.[0];

    const bestPrice = thn.parseNumber(cheapestRoom?.querySelector(priceSelectors)?.textContent);

    // Currency
    const currency = thn.data.mewsCurrency || thn.objectGet(dataLayer, 'currencyCode', { first: false }) || 'EUR';

    // Guests & Rooms
    const maxPax = thn.parseNumber(cheapestRoom?.querySelector('[data-test-id*="-max-persons"]')?.textContent);
    const guests = [...iframeBody.querySelectorAll('.Stack__StackItem-sc-hsu31d-1')].map((guest) => guest?.lastChild?.textContent);
    widgetData.adults = isHotelWithTwoPax ? 2 : thn.parseNumber(guests[3]) || (dataLayer.findLast((item) => item.eventName === 'Fetched With Occupancy')?.adultCount) || 2;
    widgetData.children = thn.parseNumber(guests[5]) || dataLayer.findLast((item) => item.eventName === 'Fetched With Occupancy')?.childCount || 0;
    widgetData.guests = widgetData.adults + widgetData.children;
    widgetData.rooms = 1;

    // price from datalayer excluding parking
    if ([1054142, 1043911].includes(thn.data.propertyId) || thn.data.accountUserId === 1036629) {
      const itemsDL = thn.dataLayerHelper.get('items');
      const isExcludeParkingProperty = thn.data.propertyId === 1043911;
      const roomsEl = isExcludeParkingProperty ? itemsDL?.filter((room) => room.item_name.toLowerCase().includes('room')) : itemsDL;
      const roomPrices = roomsEl?.map((room) => thn.parseNumber(room.price)).filter(Boolean);
      const correctGuests = [...iframeBody.querySelectorAll('[data-test-id="category-card-max-persons"]')]?.map((maxPersons) => thn.parseNumber(maxPersons?.textContent?.split(':')?.[1])).filter((Boolean)).filter((maxPersons) => maxPersons >= widgetData.guests);
      if (roomPrices && correctGuests.length) {
        widgetData.price = Math.min(...roomPrices);
        widgetData.currency = currency;
        return widgetData;
      }
      widgetData.noRooms = true;
      return widgetData;
    }

    // For this property, we need to take the room price according to the number of guests selected by the user and compare it with the maximum number of guests for each room.
    // If the cheapest room does not align with the number of guests, we need to find the cheapest room that fits the number of guests.
    if (!bestPrice || [1042491, 1030604, 1030605, 1030606, 1048768, 1034599, 1034598].includes(thn.data.propertyId) || maxPax !== widgetData.guests) {
      const roomsArray = [...iframeBody.querySelectorAll('[data-test-id="category-card"]')].filter((item) => !item.querySelector('[aria-disabled="true"]')).map((item) => {
        const price = thn.parseNumber(item.querySelector('[data-test-id="from-price-value"]')?.textContent);
        const currencyRoom = thn.parseCurrency(item.querySelector('[data-test-id="from-price-value"]')?.textContent);
        const maxOcuppancy = thn.parseNumber(item.querySelector('[data-test-id="category-card-max-persons"]')?.textContent);

        return {
          price: price,
          currency: currencyRoom,
          maxOcuppancy: maxOcuppancy,
        };
      });

      const availableRooms = [...roomsArray].filter((room) => widgetData.guests <= room.maxOcuppancy);
      widgetData.currency = currency;

      if (!thn.empty(availableRooms)) {
        widgetData.price = Math.min(...availableRooms.map((room) => room.price));
      } else {
        widgetData.price = Math.min(...roomsArray.map((room) => room.price));
        widgetData.adults = roomsArray.filter((room) => room.price === widgetData.price)?.[0]?.maxOcuppancy;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults;
        widgetData.priceSpecial = 1;
      }
    }

    const noAvailability = !!iframeBody.querySelector('[data-test-textkey="NotEnoughSpaceForGuests"]') || ([...container].map((room) => room.querySelector('[data-test-id="chevron_left"]')) && !thn.objectGet(window.dataLayer, 'page_title', { first: false })?.match(/Rates|Categories/)) || thn.empty(thn.objectGet(dataLayer, 'items', { first: false }));

    if (bestPrice && !widgetData.price) {
      widgetData.price = bestPrice;
      widgetData.currency = currency;
      widgetData.priceSpecial = maxPax !== widgetData.guests ? 1 : 0;
    } else if (noAvailability || thn.empty(bestPrice)) {
      // Aprox HTML to noRooms
      // <button>Try selecting other dates</button>  /  <button>Please select different dates.</button>
      // <p><span>You may also contact us at info@hotelbigmama.com or +493048478787.</span></p>  /  <p><span>You can also contact us at augusto@slowsuites.com or 34915311883.</span></p>
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_163
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    if (!document.querySelector || !$) {
      return;
    }
    const $iframe = $('iframe.mews-distributor:last, iframe.mews-distributor');
    const $iframeBody = $iframe && $iframe.contents().find('body');
    let $container = $iframeBody && $iframeBody.contents().find('#portal-container')
      .next()
      .find('div')
      .next('div:eq(0)');
    if ($container && !$container.length) {
      $container = $iframeBody.contents().find('[class*=ContentContainer]');
    }

    if ($container && $container.length) {
      const observer = thn.debounce(function thnMewsBookingObserver() {
        const loading = $('svg[class*=ProgressCircularSvg], [class*=style__CircleLoaderWrapper]:visible', $container).length > 0;
        // If not loading, refresh the PW and if PW is not set, hide it
        if (!loading) {
          if (ctx.widget.setData().isSet()) {
            thn.stopObserveDom($container.get(0), observer);
            ctx.widget.save();
          }
        }
      }, 800);

      thn.observeDom($container.get(0), observer);
      thn.pageUnload(function () {
        thn.stopObserveDom($container.get(0), observer);
      });
    }

    const onCheckoutSuccessEvent = ({ message }) => {
      if (message && (message.eventName === 'Confirmation Loaded' || message.event === 'purchase')) {
        thn.pageCheck();
      } else if (message && message.event === 'purchase' && this.setData().isSet()) {
        this.save();
        thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
      }
    };

    thn.bus.on('dataLayer:push', onCheckoutSuccessEvent);
    thn.shutdown(() => {
      thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
    });
  };

  /**
     * @memberOf module:bs_163
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const reservationIdsDl = thn.dataLayerHelper.get('reservationIds');
    const multiroomUsers = [1041053, 1041770].includes(thn.data.accountUserId);

    if (reservationIdsDl) {
      thn.logger.debug('Saving data from purchase event in dataLayer', dataLayer);
      const isMultiroom = reservationIdsDl.split(',').length > 1;

      if (isMultiroom && multiroomUsers) {
        const bookingItemsData = thn.dataLayerHelper.get('ecommerce.items');
        const widgetDataMulti = bookingItemsData.filter((item) => item.confirmationNumber).map((item) => ({
          bookingId: item.confirmationNumber,
          dateBegin: item.checkInDate?.replace(/-/g, '/'),
          dateEnd: item.checkOutDate?.replace(/-/g, '/'),
          adults: item.adults,
          children: item.children,
          price: item.price,
          currency: item.currency,
          promocode: item.coupon,
        }));

        return widgetDataMulti;
      }

      widgetData.bookingId = thn.dataLayerHelper.get('ecommerce.items.0.confirmationNumber');
      widgetData.dateBegin = thn.dataLayerHelper.get('ecommerce.items.0.checkInDate')?.replace(/-/g, '/');
      widgetData.dateEnd = thn.dataLayerHelper.get('ecommerce.items.0.checkOutDate')?.replace(/-/g, '/');
      widgetData.adults = thn.dataLayerHelper.get('ecommerce.items.0.adults');
      widgetData.children = thn.dataLayerHelper.get('ecommerce.items.0.children');
      widgetData.price = thn.dataLayerHelper.get('ecommerce.items.0.price');
      widgetData.currency = thn.dataLayerHelper.get('ecommerce.items.0.currency');
      widgetData.promocode = thn.dataLayerHelper.get('coupon') || thn.dataLayerHelper.get('ecommerce.items.0.coupon');

      return widgetData;
    }

    if (!document.querySelector || !$) {
      return widgetData;
    }

    const $iframe = $('iframe.mews-distributor:last, iframe.mews-distributor');
    const $iframeBody = $iframe && $iframe.contents().find('body');
    let $container = $iframeBody && $iframeBody.contents().find('#portal-container')
      .next()
      .find('div')
      .next('div:eq(0)');
    if ($container && !$container.length) {
      $container = $iframeBody.contents().find('[class*=ContentContainer], #main');
    }

    const loading = ($container && $container.length === 0) || $('svg[class*=ProgressCircularSvg], [class*=style__CircleLoaderWrapper]:visible', $container).length > 0;

    // Early exits:
    // - Page is still loading ...
    // - no dataLayer
    if (loading || !window.dataLayer) {
      // Remember to explicitly set to false
      // to avoid automatic fill of the booking data
      widgetData.set = false;
      return widgetData;
    }

    // dates
    // get dates from html
    const datesHtml = $iframe.contents().find('[class^=Card] div > div > div:nth-child(2) > p')?.[0]?.textContent?.match(/(\d{1,2})[./](\d{1,2})[./](\d{4})/g);
    const dateBeginHtml = datesHtml?.[0] || $iframe.contents().find('[class^=confirmationView__TableBase] span:nth-child(2)')[0]?.textContent
                        || $iframe.contents().find('[class^=Card] div > div > div:nth-child(2) > p > span > span:nth-child(1) > span:nth-child(2)')[0]?.textContent;
    const dateEndHtml = datesHtml?.[1] || $iframe.contents().find('[class^=confirmationView__TableBase] span:nth-child(2) span:nth-child(2)')[0]?.textContent
                      || $iframe.contents().find('[class^=Card] div > div > div:nth-child(2) > p > span > span:nth-child(2) > span:nth-child(2)')[0]?.textContent;

    const bookingData = thn.objectGet(window.dataLayer, 'reservations', { first: false }) || thn.objectGet(window.dataLayer, 'items', { first: false });
    // If we have more than one bookingData, it means that there is more than one reservation.
    // For the moment, this change only applies to one user to make sure it works properly.
    if (multiroomUsers && !thn.empty(bookingData)) {
      const bookingIds = bookingData.map((data) => data.confirmationNumber);
      const htmlDateBegin = dateBeginHtml?.replace(/(\d{2})[./-](\d{2})[./-](\d{4})/, '$3/$2/$1');
      const htmlDateEnd = dateEndHtml?.replace(/(\d{2})[./-](\d{2})[./-](\d{4})/, '$3/$2/$1');
      const dlDateBegin = thn.objectGet(dataLayer, 'startDate', { first: false })?.replace(/-/g, '/');
      const dlDateEnd = thn.objectGet(dataLayer, 'endDate', { first: false })?.replace(/-/g, '/');
      const widgetDataMulti = bookingData.map((roomBookingData, index) => {
        const roomDateBegin = htmlDateBegin || dlDateBegin || roomBookingData?.checkInDate?.replace(/-/g, '/');
        const roomDateEnd = htmlDateEnd || dlDateEnd || roomBookingData?.checkOutDate?.replace(/-/g, '/');
        const roomPrice = roomBookingData?.grossValue || roomBookingData?.price;
        const roomCurrency = roomBookingData?.currency;
        const roomData = {
          dateBegin: roomDateBegin,
          dateEnd: roomDateEnd,
          bookingId: bookingIds[index],
          price: roomPrice,
          currency: roomCurrency,
        };

        if (widgetData.promocode) {
          roomData.promocode = widgetData.promocode;
        }

        return roomData;
      });
      if (!thn.empty(widgetDataMulti) && widgetDataMulti.length === bookingIds.length) {
        return widgetDataMulti;
      }
    }

    // booking id
    const bookingId = ($iframe.contents().find('*[class*=confirmationView__TableBase] div:nth-child(3)')[0] || $iframe.contents().find('[class^=Card] div > div > div:nth-child(3) > p')[0] || {}).textContent;
    widgetData.bookingId = thn.objectGet(dataLayer, 'number', { first: false }) || bookingData?.[0]?.confirmationNumber || bookingId;

    // get data from datalayer
    const dateBeginDl = thn.objectGet(dataLayer, 'startDate', { first: false })?.replace(/-/g, '/');
    const dateEndDl = thn.objectGet(dataLayer, 'endDate', { first: false })?.replace(/-/g, '/');
    widgetData.dateBegin = dateBeginHtml?.replace(/(\d{2})[./-](\d{2})[./-](\d{4})/, '$3/$2/$1') || dateBeginDl;
    widgetData.dateEnd = dateEndHtml?.replace(/(\d{2})[./-](\d{2})[./-](\d{4})/, '$3/$2/$1') || dateEndDl;

    // price, currency and promocode
    const price = thn.objectGet(dataLayer, 'cost', { first: false })
                  || bookingData?.[0]?.grossValue
                  || $iframe.contents().find('*[class*=confirmationView__TableBase] div:nth-child(4)')[0]?.textContent
                  || $iframe.contents().find('[class^=Card] div > div > div:nth-child(4) > strong')[0]?.textContent;
    const currency = thn.objectGet(dataLayer, 'currencyCode', { first: false }) || thn.data.mewsCurrency || 'EUR';
    widgetData.price = thn.parseNumber(price);
    widgetData.currency = currency;
    widgetData.promocode = thn.objectGet(dataLayer, 'voucherCode', { first: false });

    return widgetData;
  };

  /**
     * @memberOf module:bs_163
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {

    if (!ctx.promocode) {
      ctx.promocode = thn.dataLayerHelper.get('promoCode');
    }

    return ctx.promocode;
  };

  return engine;

}

export { factory };
